import { DINEOUT_FLOW_TYPE_SESSION_STORAGE_KEY } from "@dineout-cart-client/constants";
import { DineoutCartContext, DineoutCartReducer, DineoutCartType } from "@swiggy-private/checkout-core";
import { useSessionStorage } from "@swiggy-private/core-utils";
import React, { ReactElement, useReducer, useState } from "react";
import { randomStringIdGenerator } from "@swiggy-private/core-ui";


const initialState = {
    localCart: null,
    reviewedCart: null,
};

export function DineoutCartContextProvider(props: { children: React.ReactNode }): ReactElement {
    const [cartType, setCartType] = useSessionStorage<DineoutCartType | null>(
        DINEOUT_FLOW_TYPE_SESSION_STORAGE_KEY,
        null,
    );
    const [cartState, setCartState] = useReducer(DineoutCartReducer, initialState);
    const [uniqueIdForCart, setUniqueIdForCart] = useState<string>(randomStringIdGenerator());

    const cartContextValue = React.useMemo(
        () => ({
            cartState,
            setCartState,
            cartType,
            setCartType,
            uniqueIdForCart,
            setUniqueIdForCart,
        }),
        [cartState, cartType, setCartType, uniqueIdForCart],
    );

    return <DineoutCartContext.Provider value={cartContextValue}>{props.children}</DineoutCartContext.Provider>;
}
